export default "__VITE_ASSET__CNmn_CwB__"